import { render } from "./ProductCreationView.vue?vue&type=template&id=02aa2eb9&scoped=true"
import script from "./ProductCreationView.vue?vue&type=script&lang=js"
export * from "./ProductCreationView.vue?vue&type=script&lang=js"

import "./ProductCreationView.vue?vue&type=style&index=0&id=02aa2eb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02aa2eb9"]])

export default __exports__